var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.9981C0 15.6681 15.6707 0 34.9994 0C54.3268 0 69.9975 15.6707 70 34.9994C70.0013 54.3204 54.3204 70.0013 34.9968 70C15.6707 69.9987 0 54.3242 0 34.9981ZM7.95579 34.9777C7.90481 49.8671 19.9698 61.9575 34.9611 62.0404C49.8301 62.122 61.9295 50.0621 62.0391 35.0503C62.1474 20.1788 49.9512 7.95707 35.0019 7.95579C20.0705 7.95452 8.00677 20.0067 7.95579 34.9777Z",
    fill: "url(#paint0_linear_1_1934)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0187 11.1409C21.8576 11.1078 11.15 21.8026 11.1411 34.9943C11.1309 48.1707 21.841 58.877 35.0098 58.8578C48.204 58.8387 58.9103 48.1159 58.858 34.9714C58.8058 21.7708 48.2053 11.1754 35.0187 11.1409ZM39.7702 28.6368C40.6866 28.6368 41.6999 28.6343 42.7119 28.6368C43.8195 28.6406 44.5422 29.2703 44.5435 30.2249C44.5447 31.1783 43.8195 31.813 42.717 31.8168C41.7203 31.8206 40.7249 31.8181 39.7142 31.8181C38.813 35.94 36.2894 38.1042 31.9725 38.2521C32.1599 38.4114 32.3026 38.5452 32.4581 38.6612C35.1704 40.6979 37.8839 42.7347 40.6 44.7663C41.1774 45.1984 41.4781 45.7503 41.3226 46.4704C41.1863 47.1039 40.7695 47.513 40.1437 47.68C39.5574 47.8355 39.0769 47.6035 38.6142 47.2555C34.9537 44.5038 31.2881 41.7584 27.6237 39.0117C27.1317 38.6434 26.6334 38.2839 26.149 37.9041C25.5258 37.4147 25.3155 36.7749 25.5347 36.1108C25.7679 35.406 26.3262 35.007 27.1355 35.0032C28.7262 34.9943 30.3194 35.0555 31.9062 34.9765C32.736 34.9357 33.5963 34.7661 34.3661 34.4615C35.5005 34.0129 36.111 33.0506 36.3965 31.8181H31.6424C30.1371 31.8181 28.6306 31.827 27.1254 31.8143C26.1401 31.8054 25.4391 31.1107 25.4557 30.1956C25.4722 29.3059 26.1618 28.6432 27.1228 28.6406C29.9651 28.6304 32.8073 28.6368 35.6496 28.6368H36.3978C36.0485 27.1481 35.1997 26.1654 33.7862 25.7461C33.1655 25.5613 32.4963 25.4835 31.8476 25.467C30.3207 25.4275 28.7937 25.4581 27.2656 25.453C26.1694 25.4504 25.4455 24.8017 25.4557 23.8457C25.4646 22.9128 26.1784 22.2742 27.2362 22.2742C32.4122 22.2717 37.5869 22.2704 42.7616 22.2742C43.8208 22.2742 44.5345 22.914 44.5435 23.8457C44.5537 24.8017 43.8272 25.4504 42.731 25.453C41.3367 25.4581 39.9423 25.4542 38.5607 25.4542C38.9736 26.5402 39.3547 27.542 39.7702 28.6368Z",
    fill: "url(#paint1_linear_1_1934)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1934",
    x1: 34.8715,
    y1: -11.3061,
    x2: 34.947,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1934",
    x1: 34.9121,
    y1: 3.43381,
    x2: 34.9635,
    y2: 58.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment-icon.1e330bd1d377ee202ad7aa661a65009f.svg";
export { ForwardRef as ReactComponent };